<template>
  <div class="user">
    <div class="photo">
      <img :src="photo" alt="avatar">
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{name}}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <a href="#" @click="logout">
                  <span class="sidebar-mini">lg</span>
                  <span class="sidebar-normal">Logout</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { mapGetters } from "vuex";
export default {
  name: "userMenu",
  components: {
    CollapseTransition
  },
  props: {},
  data() {
    return {
      isClosed: true,
      name: "",
      photo: ""
    };
  },
  created() {
    // this.user = firebase.auth().currentUser;
    if (this.user) {
      this.name = this.user.name;
      this.photo = this.getUser.google.photoURL;
    }
  },
  computed: {
    ...mapGetters({
      getUser: "users/user"
    }),
    user() {
      if (this.getUser) {
        this.name = this.getUser.name;
        this.photo = this.getUser.google.photoURL;
        return this.getUser;
      }
    }
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    logout() {
      this.$store
        .dispatch("users/logout")

        .then(res => {
          this.$router.push("/");
        });
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
